import { createContext, useContext } from 'react';

export const PermissionCompareContext = createContext<ReadonlySet<string> | undefined>(undefined);

export const usePermissionCompare = () => useContext(PermissionCompareContext);
